(function () {
    angular.module('st').requires.push('countUpModule');

    function VIPSubscriptionController($scope, $compile, $timeout, $http, $window, $sce, $q) {
        var ctrl = this;
        ctrl.resultcap = 50;
        ctrl.resultcapold = 50;
        ctrl.addPoints = {};
        ctrl.removePoints = {};
        ctrl.expirationDateInvalid = false;
        ctrl.invalidDate = false;
        ctrl.invalidMemberId = false;
        $scope.processing = false;
        $scope.feedback = null;
        $scope.isError = false;
        $scope.isSuccess = false;
        ctrl.mismatchPointsModal = {
            MembershipID: '',
            Resolution: '',
            Fixed: false
        };

            var isValidDate = function(dateString) {
                 const date = moment(dateString, "MM-DD-YYYY", true); // Strict parsing
                 return date.isValid();
            }

            var isStringOfNumbers = function(str) {
              return _.isString(str) && /^[0-9]+$/.test(str);
            }

            var validateFields = function (data) {
                console.log('add:' + data);

                //check if a date is set, if so, ensure it is formatted right                
                if (_.isEmpty(data.expiration)) {
                    
                } else {
                    //QoL, if date entered as 01/01/2026, swap to 01-01-2026 for conversions
                    if (data.expiration.split("/").length === 3) {
                        data.expiration = data.expiration.replace("/","-");
                        data.expiration = data.expiration.replace("/","-");
                        data.expiration = data.expiration.replace("/","-");
                    }
                    var hasDate = !_.isEmpty(data.expiration) && isValidDate(data.expiration);
                
                    if (!hasDate) {
                        ctrl.invalidDate = true;
                        $scope.feedback = 'Invalid date, must be formatted MM-DD-YYYY, i.e. 01-24-2025';
                        return false;
                    }
                }

                if (_.isEmpty(data.memberid)) {
                    ctrl.invalidMemberId = true;
                    $scope.feedback = 'The "C Rewards Member ID" field is required';
                    return false;
                }

                return true;
            }


        ctrl.checkMember = function(memberid) {
            if (ctrl.recheckingMember) {
                return;
            }

            ctrl.recheckingMember = true;
            ctrl.mismatchPointsModal = {
                MembershipID: memberid,
                Resolution: '',
                Fixed: false
            };
            
             var config = {
              memberid: memberid
            };
                
            $http.post("/rpc/membership/account/re-check-member", config)
            .then(function (d) {
                                    console.log(d);
                                    var data = JSON.parse(_.get(d, 'data'));
                                    if (data) {
                                        console.log('success');
                                                    ctrl.mismatchPointsModal.Resolution =  data.Message;
                                                    ctrl.mismatchPointsModal.Fixed =  data.Fixed;
                                                               
                                    } else {
                                        console.log('error');
                                                    ctrl.mismatchPointsModal.Resolution = "error!";
                                    }
                                }).catch(function (error) {
                                    ctrl.mismatchPointsModal.Resolution =  error;
                                })
                                .finally(function() {                   
                                    ctrl.recheckingMember = false;
                                    $('#mismatchPointsModal').modal('show');
                                });
            
        }

        ctrl.resetAddRemovePoints = function () {
            ctrl.addPoints = {
                memberid: null,
                points: 0,
                expiration: null
            };
            ctrl.removePoints = {
                memberid: null,
                points: 0        
            };
        }
        ctrl.clear = function () {
            ctrl.expirationDateInvalid = false;
            $scope.feedback = null;
            $scope.isError = false;
            $scope.isSuccess = false;
        }
        ctrl.removePointsFunc = function () {
            console.log('start');
            if ($scope.processing) {return;} else { $scope.processing = true; }

            ctrl.clear();

            var valid = validateFields(ctrl.removePoints)
            if (!valid) {                
                $scope.processing = false;
                $scope.isError = true;
                return;
            }

            ctrl.addOrRemovePoints(ctrl.removePoints, 'remove');
        }
        ctrl.addPointsFunc = function () {
            console.log('start');
            if ($scope.processing) {return;} else { $scope.processing = true; }

            ctrl.clear();

            var valid = validateFields(ctrl.addPoints)
            if (!valid) {                
                $scope.processing = false;
                $scope.isError = true;
                return;
            }

            ctrl.addOrRemovePoints(ctrl.addPoints, 'add');
        }


        //not used currently/hidden
        ctrl.recheckBalances = function() {
            if (ctrl.recheckingbalances) {
                return;
            }
            ctrl.recheckingbalancesFeedback = '';                                        
            ctrl.recheckingbalancesError = false;
            ctrl.recheckingbalances = true;

            var ids = _.map(ctrl.mismatchedsubs, 'MembershipID');

            if (_.isEmpty(ids)) {
                console.log('no ids to re-check');
                return;
            }

             var config = {
              memberIds: ids
            };
                
            $http.post("/rpc/membership/account/re-check-vip-balances", config)
            .then(function (d) {
                                    console.log(d);
                                    if (d) {
                                        console.log('success');
                                        ctrl.recheckingbalancesFeedback = 'Success: ' + d;                                        
                                        ctrl.recheckingbalancesError = true;
                                        //                             
                                    } else {
                                        // vista error 
                                        console.log('error');
                                        ctrl.recheckingbalancesFeedback = 'Error: ' + d;                                        
                                        ctrl.recheckingbalancesError = true;
                                    }
                                    ctrl.recheckingbalances = true;
                                }).catch(function (error) {
                                    console.log(arguments, error);
                                    ctrl.recheckingbalances = true;
                                });
        }

        ctrl.addOrRemovePoints = function(data, condition) {
            var url = "/rpc/membership/account/add-remove-points";
            console.log(data);
            var config = {
                memberId: data.memberid,
                expirationDate: data.expiration,
                points: data.points,
                condition: condition
            };

            $http.post(url, config)
                                .then(function (d) {
                                    console.log(d);
                                    if (d.data.Success == true) {
                                        var result = d.data.Data;
                                        console.log('success', result);
                                        $scope.feedback = d.data.Data;
                                        $scope.isSuccess = true;
                                        //                             
                                    } else {
                                        // vista error 
                                        $scope.feedback = 'Error: ' + d.data.Data;                                        
                                        $scope.isError = true;
                                    }
                                    $scope.processing = false;
                                }).catch(function (error) {
                                    console.log(arguments, error);
                                    $scope.processing = false;
                                    $scope.isError = true;
                                    $scope.feedback = error;
                                });
                        
        }

        ctrl.reloadPage = function () {
            $window.location.reload();
        }

        ctrl.showMore = function () {
            ctrl.resultcap += 25;
            ctrl.reloadToolTips();
        }
        
        ctrl.showMoreOld = function () {
            ctrl.resultcapold += 25;
            ctrl.reloadToolTips();
        }

        //sorting active
        ctrl.sortByOptions = {
            customername: false,
            memberid: false,
            memberemail: false,
            vippoints: false,
            subscriptionstatus: false,
            PaidThroughDate: false,
            subscriptionid: false,
            btsubs: false
        }

        ctrl.propertyName = 'memberid';
        ctrl.sortByOptions['memberid'] = true;
        ctrl.reverse = true;

        ctrl.sortBy = function(propertyName) {
            Object.keys(ctrl.sortByOptions).forEach(v => ctrl.sortByOptions[v] = false);

            ctrl.reverse= (ctrl.propertyName === propertyName) ? !ctrl.reverse : false;
            ctrl.propertyName = propertyName;

            ctrl.sortByOptions[propertyName] = true;

            ctrl.reloadToolTips();
          };
          
          //sorting old
        ctrl.sortByOptionsOld = {
            customername: false,
            memberid: false,
            memberemail: false,
            vippoints: false,
            subscriptionstatus: false,
            PaidThroughDate: false,
            subscriptionid: false,
            btsubs: false
        }
        ctrl.propertyNameOld = 'memberid';
        ctrl.sortByOptionsOld['memberid'] = true;
        ctrl.reverseOld = true;
        ctrl.sortByOld = function(propertyNameOld) {
            Object.keys(ctrl.sortByOptionsOld).forEach(v => ctrl.sortByOptionsOld[v] = false);

            ctrl.reverseOld = (ctrl.propertyNameOld === propertyNameOld) ? !ctrl.reverseOld : false;
            ctrl.propertyNameOld = propertyNameOld;

            ctrl.sortByOptionsOld[propertyNameOld] = true;
          };

          ctrl.reloadToolTips = function() {
                          $timeout(function() {
                $('[data-toggle="tooltip"]').tooltip();
        });
          }

        var memberByPointCount = {};

        ctrl.filterOptions = {
            searchTerm: null,
            viptype: null,
            status: null,
            vippoints: null,
            points: null
        }

        function isGreaterThanFiveYears(date) {
            const fiveYearsFromNow = moment().add(5, 'years');
            return moment(fiveYearsFromNow).isBefore(date);
        }

        var d = new Date();
        var today = moment(d, "America/New_York").startOf('day');
        ctrl.daysRemaining = function (date) {
            if (date) {
                var sub = moment(date, 'YYYY-MM-DD', 'America/New_York').startOf('day');
                var daysRemaining = sub.diff(today, 'days');
                //daysRemaining = daysRemaining < -1000 ? 1000 : daysRemaining; //free vip subs sometimes are wonky dates as they are big if infinite.
                daysRemaining = daysRemaining < 0 ? 0 : daysRemaining;
                if (daysRemaining > 500 || daysRemaining < -500) {
                    return "";
                } else {
                    return $sce.trustAsHtml("<span data-toggle='tooltip' data-placement='top' title='"+daysRemaining+" days left in subscription cycle'><i class='fal fa-history'></i> "+daysRemaining+" days</span>");
                }
            } else {
                return "";
            }
        }


        ctrl.formatDate = function (item) {
            if (item) {
                //check if non-expiring sub (if greater than 5 years it is probably meant to not expire)
                if(isGreaterThanFiveYears(item)) {
                    return $sce.trustAsHtml("<span data-toggle='tooltip' data-placement='top' title='This sub has no expiration (or is very far out)'><i class='far fa-infinity'></i></span>");
                } else {
                    return moment(item, "YYYY-MM-DDTHH:mm:ss").format('MMM Do');
                }
            } else {
                return "N/A";
            }
        }

        $scope.init = function () {
            json = window.vipSubscriptions;            
            
            //set null VIPs to 0 (sometimes valid use-case, but easy to find if they are 0)
            _.forEach(json, function(value) {
                if (value.vippoints === null) {
                    value.vippoints = 0;
                }
            });
            
            //test visuals
            //json[0].subscriptionstatus = 'canceled';
            //json[1].subscriptionstatus = 'free';
            //json[2].subscriptionstatus = 'expired';
            //json[3].subscriptionstatus = 'pastdue';

            json = json.map(obj => ({ ...obj, viptype: obj.subscriptionstatus === 'free' ? 'free' : 'paid' }));
            json = _.map(json, o => _.extend({btsubs: 0}, o));

            //set null VIPs to 0 (sometimes valid use-case, but easy to find if they are 0)
            _.forEach(json, function(value) {
                if (value.vippoints === null) {
                    value.vippoints = 0;
                }
                if (value.subscriptionstatus !== 'free' && !_.isEmpty(value.memberid)) {
                    
                    value.btsubs = _.filter(json, ['memberid', value.memberid]).length;
                }
            });

            try {
                ctrl.totalactivesubscriptions = _.filter(json, function (o) { return o.subscriptionstatus === 'active'; }).length;
                ctrl.totalactivesubscriptionsfree = _.filter(json, function (o) { return o.subscriptionstatus === 'free'; }).length;
                
                var totalFreePointUsers = totalactivesubscriptionsfree = _.filter(json, function (o) { return o.subscriptionstatus === 'free'; })
                var totalFreePoints = _.sumBy(totalFreePointUsers, 'vippoints');
                ctrl.totalusersubscriptionsPoints = totalFreePoints;
            } catch (error) {
                console.log('active total error', error);
                ctrl.subscriptions = null;
            }            
            
            try {
                var adayago = moment().subtract(1, 'days').startOf('day');
                console.log('day ago', adayago)

                var oldSubs = _.filter(json, function (o) { return adayago.isAfter(o.LastModifiedDate); });
                var noPointSubs = _.filter(json, function (o) { return o.vippoints === null; });
                var noIdSubs = _.filter(json, function (o) { return _.isEmpty(o.memberid); });
                var noEmailSubs = _.filter(json, function (o) { return _.isEmpty(o.memberemail); });

                var combinedIssues = _.union(oldSubs, noPointSubs, noIdSubs, noEmailSubs);

                //if we have duplicate issues on a sub, just show the one version of it
                ctrl.subscriptionsold = _.uniqBy(combinedIssues, 'subscriptionid');

                console.log('--issue subs--', ctrl.subscriptionsold.length);
                console.log('old', oldSubs);
                console.log('points', noPointSubs);
                console.log('ids', noIdSubs);
                console.log('emails', noEmailSubs);
            } catch (error) {
                console.log('sub old total error', error);
                ctrl.subscriptions = null;
            }

                ctrl.totalactivebutendingsubscriptions = _.filter(json, function (o) { return o.subscriptionstatus !== 'active' && o.subscriptionstatus !== 'free'; }).length;

            try {
                var nonfree = _.filter(json, function (o) { return o.subscriptionstatus !== 'free'; }).length;
                var free = _.sumBy(_.filter(json, function (o) { return o.subscriptionstatus === 'free'; }), 'vippoints');
                ctrl.grandtotalactivesubscriptions = free + nonfree;
            } catch (error) {
                console.log('grand total error', error);
                ctrl.subscriptions = null;
            }
            try {
                //BT points
                var combinedPaidSubs = _.filter(json, function (o) { return o.subscriptionstatus !== 'free'; });
                var combinedSubs = _.groupBy(combinedPaidSubs, 'memberid');

                ctrl.totalvipsubsperuser = combinedSubs;
                ctrl.totalusersubscriptions = Object.keys(combinedSubs).length;

                //Total VIP Users
                var combinedSubs2 = _.groupBy(json, 'memberid');
                ctrl.totalvipusersubscriptions = Object.keys(combinedSubs2).length;
            } catch (error) {
                console.log('subscriber total error', error);
                ctrl.subscriptions = null;
            }
            try {
                ctrl.subscriptions = _.sortBy(json, ['memberid', 'memberemail']);
            } catch (error) {
                console.log('sort subs error', error);
                ctrl.subscriptions = null;
            }
            try {
                var substatuses = [...new Set(ctrl.subscriptions.map(function (item) { return item.subscriptionstatus; }))].sort() || null;
                ctrl.filtersubscriptionstatuses = substatuses.sort();
            } catch (error) {
                console.log('error sub status filter', error);
            }
            try {
                var a = Object.entries(ctrl.totalvipsubsperuser).map((e) => ({ 'id': e[0], 'count': e[1].length }));
                var b = [...new Set(a.map(function (item) { return item.count; }))]
                memberByPointCount = a;
                ctrl.filtersubscriptionpoints = b.sort();
            } catch (error) {
                console.log('error sub status filter', error);
            }
            try {
                // var vipoints = [...new Set(ctrl.subscriptions.map(function (item) { return item.vippoints || 0; }))].sort() || null;
                var vipoints = [...new Set(ctrl.subscriptions.map(function (item) { return _.isNumber(_.toNumber(item.vippoints)) ? (item.vippoints == null ? 0 : item.vippoints) : 0; }))].sort() || 0;
                //console.log('allpoints', vipoints);
                // var vipointsempty = _.filter(ctrl.subscriptions, function(o) { return _.isNaN(o.vippoints); });
                var vipointsempty = _.groupBy(_.filter(ctrl.subscriptions, function(o) { return o.vippoints === null; }), "memberid");
                //console.log('no points', vipointsempty)
                //console.log('---');
                ctrl.filtervippoints = vipoints.sort();
            } catch (error) {
                console.log('error sub status filter', error);
            }

            $(document).ready(function () {
                $(function () {
                    ctrl.reloadToolTips();
                });
            });

            ctrl.reloadToolTips();
            ctrl.getVistaVIPs();
        }

        ctrl.getVistaVIPs = function() {
            var VIPPointsUrl = "https://api.celebrationcinema.com/CDN/StudioC-VIP/VIPExport.JSON";

            $http.get(VIPPointsUrl)
                .then(function(d) {
                    console.log(d);
                    $timeout(function() {
                    if (_.get(d, 'status') === 200) {
                        //console.log('success');
                        ctrl.compareMissingVIPs(d.data);
                    } else {
                        console.log('error no data');
                    }
                    });
                }).catch(function(error) {
                    console.log('catch error no data', arguments);
                });                       
        }

        ctrl.compareMissingVIPs = function(vistadata) {
            //console.log('comparing..');
            //console.log('v', vistadata);
            //console.log('sf', ctrl.subscriptions);

            var result = [];

            const vistaGrouped = _(vistadata)
                .groupBy('MembershipID')
                .map((sub) => {
                        var pointsOf22 = _.filter(sub, {'BalanceTypeID': 22 });
                        return {
                            MembershipID: sub[0].MembershipID,
                            BalanceCount: _.sumBy(pointsOf22, 'BalanceCount'),
                            Subscriptions: _.values(sub)
                        }
                    
                })
            .value();
            
            const sfGrouped = _(ctrl.subscriptions)
                .groupBy('memberid')
                .map((sub) => {
                        return {
                            MembershipID: sub[0].memberid,
                            BalanceCount: _.sumBy(sub, 'vippoints'),
                            Subscriptions: _.values(sub)
                        }
                    
                })
            .value();
            //console.log(vistaGrouped,sfGrouped);
            _.each(vistaGrouped, function(v) {
                var sfsub = _.find(sfGrouped, {'MembershipID': v.MembershipID });
                if (sfsub) {
                    if (sfsub.BalanceCount !== v.BalanceCount) {
                        //incorrect sf result for this member, add to problem list
                        v['sfsub_viewpoint'] = sfsub;
                        result.push(v);
                    }
                } else {
                    //no sf result for this member, add to problem list
                    v['sfsub_viewpoint'] = sfsub;
                    result.push(v);
                }
            });

            console.log('mis-matched point 22 balances', result);

            //ctrl.mismatchedsubs = result;

            ctrl.checkMisMatchUsers(result);

            // $timeout(function(){ 
            //     ctrl.reloadToolTips();
            // },1000);
        }

        ctrl.getPointProblem = function(sub) {
            var vistaBalance = sub.BalanceCount;
            var vistaFreeBalance = _.get(_.find(sub.Subscriptions, {'BalanceTypeID': 27}), 'BalanceCount') || 0;
            var sfBalance = _.isEmpty(sub.sfsub_viewpoint) ? 0 : sub.sfsub_viewpoint.BalanceCount;
            var sfFreeBalance = _.isEmpty(sub.sfsub_viewpoint) ? 0 : (_.get(_.find(sub.sfsub_viewpoint.Subscriptions, {'SubType': 'VistaBalType_27'}), 'vippoints') || 0);

            if (vistaFreeBalance === sfFreeBalance) {
                if (vistaBalance < sfBalance) {
                    var offset = sfBalance - vistaBalance;
                    return $sce.trustAsHtml("<div>Missing <strong class='vista'>"+ offset +"</strong> (Balance Type 22) points in <strong class='vista'>Vista</strong></div>");
                } else {
                    var offset = vistaBalance - sfBalance;
                    return $sce.trustAsHtml("<div>Missing <strong class='sitefinity'>"+ offset +"</strong> (Balance Type 22) points in <strong class='sitefinity'>Sitefinity</strong></div>");
                }
            } else {
                if (vistaFreeBalance < sfFreeBalance) {
                    var offset = sfFreeBalance - vistaFreeBalance;
                    return $sce.trustAsHtml("<div>Missing <strong class='vista'>"+ offset +"</strong> (Balance Type 27 / Gifted) points in <strong class='vista'>Vista</strong></div>");
                } else {
                    var offset = vistaFreeBalance - sfFreeBalance;
                    return $sce.trustAsHtml("<div>Missing <strong class='sitefinity'>"+ offset +"</strong> (Balance Type 27 / Gifted) points in <strong class='sitefinity'>Sitefinity</strong></div>");
                }
            }
        }

        $scope.filterByOptions = function (item) {
            var passesFilter = true;
            //console.log('filters', ctrl.filterOptions);

            if (ctrl.filterOptions.searchTerm) {
                if (item.customername.toLowerCase().includes(ctrl.filterOptions.searchTerm.toLowerCase()) ||
                    item.subscriptionid.toLowerCase().includes(ctrl.filterOptions.searchTerm.toLowerCase()) ||
                    item.memberid.toLowerCase().includes(ctrl.filterOptions.searchTerm.toLowerCase()) ||
                    item.memberemail.toLowerCase().includes(ctrl.filterOptions.searchTerm.toLowerCase())) {
                    //do nothing it passes
                } else {
                    passesFilter = false;
                }
            }

            if (ctrl.filtersubscriptionstatuses) {
                if (ctrl.filterOptions.status) {
                    if (ctrl.filterOptions.status.indexOf(item.subscriptionstatus) > -1) {
                        //do nothing it passes
                    } else {
                        passesFilter = false;
                    }
                }
            }
            if (ctrl.filtervippoints) {
                if (_.isNumber(ctrl.filterOptions.vippoints)) {
                    if (ctrl.filterOptions.vippoints === item.vippoints) {
                        //do nothing it passes
                    } else {
                        passesFilter = false;
                    }
                }
            }

            if (ctrl.filtersubscriptionpoints) {
                if (_.isNumber(ctrl.filterOptions.points)) {
                    var result = _.find(memberByPointCount, { 'id': item.memberid, 'count': ctrl.filterOptions.points });
                    if (result) {
                        //do nothing it passes
                    } else {
                        passesFilter = false;
                    }
                }
            }


            if (ctrl.filterOptions.viptype) {                
                if (ctrl.filterOptions.viptype === item.viptype) {
                    //do nothing it passes
                } else {
                    passesFilter = false;
                }
            }


            if (passesFilter) {
                return item;
            }
        }
        ctrl.reloadToolTips();


        ctrl.checkMisMatchUsers = function (usersToCheck) {
            //console.log(usersToCheck);
            var defer = $q.defer();
            var promises = [];

            _.each(usersToCheck, function (u) {
                var ID = u.MembershipID;
                if (ID) {
                    promises.push(getIfNoWebsiteUser(ID));
                    return;
                }
            });

            //check sf users
            $q.all(promises)
                .then(function (response) {

                    var newArray = [];
                    var IDsToRemoveAsTheUserDoesntUseTheWebsiteAndThatIsOkay = []; //they will have mismatch points as they have no SF Subs because they don't use the website, this is fine
                    console.log('all', response);
                    _.each(response, function (r) {
                        var d = _.get(r, 'data');
                        var parsed = JSON.parse(d);
                        if (_.get(parsed, 'NoWebsiteUser')) {
                            IDsToRemoveAsTheUserDoesntUseTheWebsiteAndThatIsOkay.push(parsed.MembershipID)
                        }
                    });

                    var removeElements = _.remove(usersToCheck, obj => IDsToRemoveAsTheUserDoesntUseTheWebsiteAndThatIsOkay.includes(obj.MembershipID));
                    ctrl.mismatchedsubs = removeElements;
                    ctrl.NonWebsiteUserCount = usersToCheck;


                     //now check vista users                     
                    defer = $q.defer();
                    promises = [];

                    _.each(removeElements, function (u) {
                        var ID = u.MembershipID;
                        if (ID) {
                            promises.push(getIfNoVistaUser(ID));
                            return;
                        }
                    });
                   
                    $q.all(promises)
                        .then(function (response) {
                            var newArray = [];
                            var IDsToRemoveAsTheUserDontExistInVistaAndThatIsOkay = []; //they will have mismatch points as they have no SF Subs because they don't use the website, this is fine
                            console.log('all', response);
                            _.each(response, function (r) {
                                var d = _.get(r, 'data');
                                var parsed = JSON.parse(d);
                                if (_.get(parsed, 'NoVistaUser')) {
                                    IDsToRemoveAsTheUserDontExistInVistaAndThatIsOkay.push(parsed.MembershipID)
                                }
                            });

                            //removeElements = all issue users that are not website related
                            var removeElements2 = _.remove(removeElements, obj => IDsToRemoveAsTheUserDontExistInVistaAndThatIsOkay.includes(obj.MembershipID));

                            ctrl.misMatchesDone = true;
                            ctrl.mismatchedsubs = removeElements;
                            ctrl.NonVistaUserCount = removeElements2;

                            $timeout(function () {
                                ctrl.reloadToolTips();
                            }, 1000);
                        });
                });
        }

        function getIfNoWebsiteUser(memberid) {
            var deferred = $q.defer();
            //console.log('getting benton harbor data');
           var config = {
              memberid: memberid,
              cache: true
            };
            console.log('investigating member: ' + memberid)  ;
            $http.post("/rpc/membership/account/re-check-member-website", config)
                .then(deferred.resolve);
            return deferred.promise;
        }

        function getIfNoVistaUser(memberid) {
            var deferred = $q.defer();
            //console.log('getting benton harbor data');
           var config = {
              memberid: memberid,
              cache: true
            };
            console.log('investigating member: ' + memberid)  ;
            $http.post("/rpc/membership/account/re-check-member-vista", config)
                .then(deferred.resolve);
            return deferred.promise;
        }
    }

    VIPSubscriptionController.$inject = ["$rootScope", "$scope", "$timeout", "$http", "$window", "$sce", "$q"];
    angular
        .module("st")
        .controller("VIPSubscriptionController", VIPSubscriptionController);
})();